import { TimeStamped } from '../django';
import { applyTimezone, parseDate } from '../helpers/date';
import { parseNumeric } from '../helpers/number';
import { BANKING_CHARGE_STATUS } from './banking-charge-status.model';

export class BankingCharge implements TimeStamped {
  id: string;
  created: Date;
  modified: Date;
  amount: number;
  netAmount: number;
  discountAmount: number;
  discountDueDateLimitDays: number;
  dueDate: Date;
  interestAmount: number;
  fine: number;
  objectId: string;
  bankSlipUrl: string;
  paymentDate: Date;
  description: string;
  status: BANKING_CHARGE_STATUS;

  constructor(data: string | BankingCharge | DjangoBankingCharge = {}) {
    if (typeof data === 'string') {
      bindConstructorDataToInstance(this, { id: data });
    } else {
      bindConstructorDataToInstance(this, data);
    }
  }
}

export function parseBankingCharge(data?: string | BankingCharge | DjangoBankingCharge) {
  if (data) {
    return new BankingCharge(data);
  } else {
    return undefined;
  }
}

//////////////////////
/// DJANGO SUPPORT ///
//////////////////////
export interface DjangoBankingCharge {
  id?: string;
  created?: string;
  modified?: string;
  amount?: number;
  net_amount?: number;
  discount_amount?: number;
  discount_due_date_limit_days?: number;
  due_date?: string;
  interest_amount?: number;
  fine?: number;
  bank_slip_url?: string;
  object_id?: string;
  payment_date?: string;
  description?: string;
  status?: BANKING_CHARGE_STATUS;
}

///////////////
/// PRIVATE ///
///////////////
function bindConstructorDataToInstance(
  instance: BankingCharge,
  data: BankingCharge | DjangoBankingCharge,
) {
  const jsData = bindDjangoPropsToJs(data);
  instance.id = jsData.id;
  instance.created = parseDate(jsData.created);
  instance.modified = parseDate(jsData.modified);
  instance.amount = parseNumeric(jsData.amount);
  instance.netAmount = parseNumeric(jsData.netAmount);
  instance.discountAmount = parseNumeric(jsData.discountAmount);
  instance.discountDueDateLimitDays = parseNumeric(jsData.discountDueDateLimitDays);
  instance.dueDate = applyTimezone(parseDate(jsData.dueDate), 0);
  instance.interestAmount = parseNumeric(jsData.interestAmount);
  instance.fine = parseNumeric(jsData.fine);
  instance.bankSlipUrl = jsData.bankSlipUrl;
  instance.objectId = jsData.objectId;
  instance.paymentDate = applyTimezone(parseDate(jsData.paymentDate), 0);
  instance.description = jsData.description;
  instance.status = jsData.status;
}

function bindDjangoPropsToJs(data: BankingCharge | DjangoBankingCharge) {
  const djangoData = data as DjangoBankingCharge;
  const jsData = data as BankingCharge;
  return {
    ...data,
    amount: djangoData.amount || jsData.amount,
    netAmount: djangoData.net_amount || jsData.netAmount,
    discountAmount: djangoData.discount_amount || jsData.discountAmount,
    discountDueDateLimitDays:
      djangoData.discount_due_date_limit_days || jsData.discountDueDateLimitDays,
    dueDate: djangoData.due_date || jsData.dueDate,
    interestAmount: djangoData.interest_amount || jsData.interestAmount,
    fine: djangoData.fine || jsData.fine,
    bankSlipUrl: djangoData.bank_slip_url || jsData.bankSlipUrl,
    objectId: djangoData.object_id || jsData.objectId,
    paymentDate: djangoData.payment_date || jsData.paymentDate,
  } as BankingCharge;
}
